import { RegionShared } from "@1games-ru/region-shared";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import TfaMpProvider from "@/core/data-provider/data-mp/tfa/tfa-mp-provider";
import useErrorTranslation from "@/core/helpers/useErrorTranslation";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";

export default function useResetPasswordGoogleCode() {
  const tError = useErrorTranslation();
  const [checkIsPending, setCheckIsPending] = useState(false);
  const [checkError, setCheckError] = useState<string>("");
  const [checkIsCompleted, setCheckIsCompleted] = useState<null | boolean>(null);

  const checkCodeHandler = useCallback(
    async (code: string) => {
      try {
        if (checkIsPending) return;

        setCheckIsPending(true);
        setCheckError("");

        const response = await TfaMpProvider.checkGoogleCode(
          code,
          RegionShared.Backend.Events.Auth.RecoveryGoogleCheck,
        );

        if (response instanceof RpcMpProviderSuccessResponse) {
          setCheckIsCompleted(true);
        } else {
          setCheckError(tError(response.message));
          setCheckIsCompleted(false);
        }
      } catch ({ message }) {
        setCheckError(tError(message));
        setCheckIsCompleted(false);
      } finally {
        setCheckIsPending(false);
      }
    },
    [checkIsPending],
  );

  return {
    checkCodeHandler,
    checkError,
    checkIsPending,
    checkIsCompleted,
    setCheckIsCompleted,
  };
}
